{
  "RESET_PASSWORD": {
    "TITLE": "Redefinir palavra-passe",
    "DESCRIPTION": "Escreva o endereço de e-mail que usa para aceder ao Wiseteam para obter as instruções de redefinição da palavra-passe.",
    "GO_BACK_TO_LOGIN": "Se pretende voltar à página de acesso,",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Por favor, digite o seu e-mail.",
      "ERROR": "Por favor, digite um e-mail válido."
    },
    "API": {
      "SUCCESS_MESSAGE": "O link para redefinir a palavra-passe foi enviado para o seu e-mail.",
      "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot. Por favor, tente novamente."
    },
    "SUBMIT": "Submeter"
  }
}
